export default "__VITE_ASSET__DA52Mt19__"